module.exports = __webpack_public_path__ + "static/media/three_quarters_front_picture.23c54fa8.png";